module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ch-1113c7e9162d605ca580694f60526e96.svg";